module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus-sidebar-logo-967dbbe8122b61168c15b3a23a21945c.png";